export default __webpack_public_path__ + "static/media/16.17b6c1de.webp";